class Preloader {
    constructor() {
        if (Preloader.instance) {
            return Preloader.instance;
        }

        this.preloaderElement = document.getElementById('preloader');
        this.startTime = (performance && performance.timing && performance.timing.navigationStart) || Date.now();
        this.minAnimationDuration = 0;
        this.maxAnimationDuration = 600;

        Preloader.instance = this;

        this.init();
    }

    init() {
        if (!this.preloaderElement) {
            return;
        }

        const trigger = () => {
            requestAnimationFrame(() => this.hide());
        };

        if (document.readyState === 'complete' || document.readyState === 'interactive') {
            trigger();
        } else {
            document.addEventListener('DOMContentLoaded', trigger, { once: true });
        }
    }

    hide() {
        if (!this.preloaderElement || this.hideInProgress) {
            return;
        }

        this.hideInProgress = true;
        const elapsedTime = Date.now() - this.startTime;

        const animationDuration = Math.min(
            this.maxAnimationDuration,
            Math.max(this.minAnimationDuration, elapsedTime)
        );

        this.preloaderElement.style.setProperty('--preloader-animation-duration', `${animationDuration}ms`);
        this.preloaderElement.classList.add('preloader--animating');

        setTimeout(() => {
            if (!this.preloaderElement) return;

            this.preloaderElement.classList.add('preloader--hidden');

            setTimeout(() => {
                if (this.preloaderElement && this.preloaderElement.parentNode) {
                    this.preloaderElement.parentNode.removeChild(this.preloaderElement);
                    this.preloaderElement = null;
                }

                window.dispatchEvent(new CustomEvent('preloader:hidden'));
            }, 100);
        }, animationDuration);
    }
}

if (!window.preloaderInstance) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            window.preloaderInstance = new Preloader();
        });
    } else {
        window.preloaderInstance = new Preloader();
    }
}